// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__n2t-S","grid_container":"Skills_grid_container__9-Hx1","span":"Skills_span__MggV-"};